import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  games: [],
  gameUrl: "",
};

export const rsgGamesSlice = createSlice({
  name: "rsgGames",
  initialState,
  reducers: {
    setRsgGames(state, action) {
      state.games = action.payload;
    },
    setRsgGameUrl(state, action) {
      state.gameUrl = action.payload;
    },
  },
});

export default rsgGamesSlice;
